import React, {  useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ServicePrivate from "../../../services/ServicePrivate";
import ApiBack from "../../../utils/domains/ApiBack";
import { MessageToastify } from "../../../utils/funtions/MessageToastify";
import { useForm } from "../../../utils/hooks/useForm";
import News from "../../../models/News";

export const CreateNews = () => {
    const [process, setProcess] = useState<boolean>(false);
    const formRef = useRef<HTMLFormElement>(null);



    type formaHtml = React.FormEvent<HTMLFormElement>;

    const navigate = useNavigate();

    let {
        title, content, url,
        doubleLink,
        object,
    } = useForm<News>(
        new News(0, "", "", "", "", "", "", true)
    );
    const [imageBase64, setImageBase64] = React.useState("");

    // Convierte imagen a Base64 con un tamaño fijo
    const resizeImageToBase64 = (file: any, maxWidth: any, maxHeight: any) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = (event) => {
                const img = new Image();
                img.src = String(event?.target?.result);

                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");

                    canvas.width = maxWidth;
                    canvas.height = maxHeight;
                    ctx?.drawImage(img, 0, 0, maxWidth, maxHeight);

                    // Convertimos a Base64 (PNG o JPG)
                    const base64String = canvas.toDataURL("image/jpeg", 1);
                    resolve(base64String);
                };

                img.onerror = (err) => reject(err);
            };
        });
    };

    const handleImageUpload = async (event: any) => {
        const file = event.target.files[0];
        if (file) {
            try {
                const base64 = await resizeImageToBase64(file, 300, 300);
                setImageBase64(String(base64));
            } catch (error) {
                console.error("Error al procesar la imagen:", error);
            }
        }
    }

    const today = new Date();
    const eightDaysAgo = new Date(today);
    eightDaysAgo.setDate(today.getDate() - 8);

    const cleanBox = (form: HTMLFormElement) => {
        form.reset();

        object.title = "";
        object.url = "";
        object.content = "";
        object.image = "";
        object.is_active = true;

        setImageBase64("");

        form.classList.remove("was-validated");
    };

    const sendForm = async (fh: formaHtml) => {
        try {
            fh.preventDefault();
            setProcess(true);
            const form = fh.currentTarget;

            form.classList.add("was-validated");

            if (form.checkValidity() === false) {
                fh.preventDefault();
                fh.stopPropagation();
                setProcess(false);
                MessageToastify(
                    "error",
                    "Por favor, completa todos los campos requeridos.",
                    2000
                );
                return;
            }
            const formData = {
                title: object.title,
                content: object.content,
                image: imageBase64,
                url: object.url,
            };


            const response = await ServicePrivate.requestPOST(
                ApiBack.CREATE_NEWS,
                formData
            );
            console.log(response);
            
            if (response.mensaje === 'ok') {
                    MessageToastify(
                        "success",
                        "Noticia creada, ya se puede verificar en el listado.",
                        2000
                    );
                    setProcess(false);
                    cleanBox(form);
            }
            
        } catch (error) {
            setProcess(false);
            MessageToastify(
                "error",
                "Error en el momento de crear el soporte, comuniquese con el TI.",
                7000
            );
        }
    };

    return (
        <>
            <div>
                <div className="row d-flex">
                    <div className="col-12 grid-margin stretch-card justify-content-center">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title" style={{ textAlign: "center" }}>
                                    <i className="fa-solid fa-folder-plus"></i>&nbsp;Formulario
                                    de creación
                                </h4>
                                <Form
                                    className="forms-sample"
                                    validated={process}
                                    onSubmit={sendForm}
                                    noValidate
                                    ref={formRef}
                                >
                                    <div className="row ms-lg-5 me-lg-5">
                                        <div className="row">

                                            <div className="col-lg-10 col-md-12 col-sm-12">
                                                <Form.Group controlId="title">
                                                    <Form.Label className="fw-bold">
                                                        Titulo:
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        name="title"
                                                        className="form-control"
                                                        placeholder="Escriba el titulo que le quiere colocar a la noticia."
                                                        value={title}
                                                        onChange={doubleLink}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        La descripción del soportes es obligatoria, escriba
                                                        o seleccione de las plantillas ya inscritas.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-10 col-md-12 col-sm-12">
                                                <Form.Group controlId="title">
                                                    <Form.Label className="fw-bold">
                                                        Url de la noticia:
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        name="url"
                                                        className="form-control"
                                                        placeholder="Escriba el la url o dirección de internet de donde tomo la noticia."
                                                        value={url}
                                                        onChange={doubleLink}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        La descripción del soportes es obligatoria, escriba
                                                        o seleccione de las plantillas ya inscritas.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-10 col-md-12 col-sm-12">
                                                <Form.Group controlId="content">
                                                    <Form.Label className="fw-bold">
                                                        Descripción:
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        as="textarea"
                                                        name="content"
                                                        className="form-control"
                                                        placeholder="Escriba la descripción que le quiere colocar a la notica."
                                                        value={content}
                                                        onChange={doubleLink}
                                                        aria-describedby="content"
                                                        autoComplete="off"
                                                        rows={5}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        La descripción del soportes es obligatoria, escriba
                                                        o seleccione de las plantillas ya inscritas.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-10 col-md-12 col-sm-12">
                                                <Form.Group controlId="imageUpload">
                                                    <Form.Label className="fw-bold">Subir imagen:</Form.Label>
                                                    <Form.Control
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={handleImageUpload} // función que convierte a base64
                                                        required
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Debe seleccionar una imagen.
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                {imageBase64 && (
                                                    <div className="mt-3">
                                                        <Form.Label className="fw-bold">Vista previa:</Form.Label>
                                                        <img
                                                            src={imageBase64}
                                                            alt="preview"
                                                            style={{ width: "200px", borderRadius: "10px", display: "block" }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div
                                            className="col-lg-12 col-sm-12 mt-7  d-flex justify-content-center"
                                            style={{
                                                padding: "10px",
                                            }}
                                        >
                                            <button
                                                type="submit"
                                                className="btn btn-outline-info button-create badge fs-6 p-2 pe-3 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                                disabled={process}
                                            >
                                                {process ? (
                                                    <>
                                                        <i className="fa-solid fa-spinner fa-spin"></i>
                                                        &nbsp;Guardando...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fa-solid fa-plus"></i>&nbsp;Guardar
                                                    </>
                                                )}
                                            </button>
                                            &nbsp;
                                            <button
                                                type="button"
                                                onClick={() => navigate(-1)}
                                                className="badge d-flex align-items-center fs-6 p-2 pe-3 text-info-emphasis bg-info-subtle border border-info-subtle rounded-pill"
                                            >
                                                <i className="fa-solid fa-arrow-left-long"></i>
                                                &nbsp;Regresar
                                            </button>
                                            &nbsp;
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (formRef.current) {
                                                        cleanBox(formRef.current);
                                                    }
                                                }}
                                                className="badge d-flex align-items-center fs-6 p-2 pe-3 text-danger-emphasis bg-danger-subtle border border-danger-subtle rounded-pill"
                                            >
                                                <i className="fa-solid fa-broom"></i>&nbsp;Limpiar
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>

                <ToastContainer />
            </div>
        </>
    );
};
